// Erstelle eine neue Datei: custom-paginator-intl.ts

import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
	private _translate: TranslateService;

	constructor(translate: TranslateService) {
		super();
		this._translate = translate;
		this.translateLabels();

		// Abonniere Änderungen der Sprache
		this._translate.onLangChange.subscribe(() => {
			this.translateLabels();
		});
	}

	translateLabels(): void {
		this.itemsPerPageLabel = this._translate.instant('paginator.itemsPerPage');
		this.nextPageLabel = this._translate.instant('paginator.nextPage');
		this.previousPageLabel = this._translate.instant('paginator.previousPage');
		this.firstPageLabel = this._translate.instant('paginator.firstPage');
		this.lastPageLabel = this._translate.instant('paginator.lastPage');
		this.changes.next();
	}

	getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0) {
			return this._translate.instant('paginator.emptyPage');
		}

		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ?
			Math.min(startIndex + pageSize, length) :
			startIndex + pageSize;

		return this._translate.instant('paginator.range', {
			startIndex: startIndex + 1,
			endIndex,
			length
		});
	};
}
